import React from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router'
import {
  ProsperityAssessmentResult as ProsperityAssessmentResultSection,
  useResolutionService,
  surveyType,
  PrintableArea,
} from '@abroad/components'
import API from '../utils/API'

const ProsperityAssessmentResult = () => {
  const { clientId, id } = useParams()
  const { isLGScreen } = useResolutionService()
  return (
    <>
      <Helmet>
        <title>True Prosperity Result | Abroad</title>
        <meta name='title' content='True Prosperity Result | Abroad' />
        <meta property='og:title' content='True Prosperity Result | Abroad' />
        <meta
          property='twitter:title'
          content='True Prosperity Result | Abroad'
        />
        <link
          rel='canonical'
          href={`${process.env.REACT_APP_DOMAIN}/prosperity/${id}/clients/${clientId}`}
        />
        <meta
          property='og:url'
          content={`${process.env.REACT_APP_DOMAIN}/prosperity/${id}/clients/${clientId}`}
        />
        <meta
          property='twitter:url'
          content={`${process.env.REACT_APP_DOMAIN}/prosperity/${id}/clients/${clientId}`}
        />
      </Helmet>
      <ProsperityAssessmentResultSection
        isRenderOnAdmin={true}
        isLGScreen={isLGScreen}
        API={API.ClientAPI}
        renderHeader={() => {
          return null
        }}
        AssessmentEvent={'AssessmentEvent'}
        clientId={clientId}
        apiFunction={() => {
          return API.CoachAPI.coachClient.getUserSurveyResult(
            id,
            clientId,
            surveyType.PROSPERITY,
          ) // (surveyId, clientId, surveyType)
        }}
      />
      <PrintableArea printSelector='main' />
    </>
  )
}

export default ProsperityAssessmentResult
